import React from 'react';
import './BatteriesCard.scss';
import { useAppDispatch, useAppSelector } from '../../../../app/hooks';
import { bookingActions, bookingSelector } from '../../../../features/bookingSlice';
import { customerDetailsSelector } from '../../../../features/customerSlice';
import { getLithiumSurcharges } from '../../../../utilities/HelperUtilities';

const BatteriesCard = () => {

  const dispatch = useAppDispatch();
  const booking = useAppSelector(bookingSelector);
  const customer = useAppSelector(customerDetailsSelector);
  const currencySymbol = customer.countryOfResidence.currencySymbol;

  const lithiumCharges = getLithiumSurcharges(booking.selectedQuote);

  const handleToggle = (chargeType: string) => {
    const current = booking.selectedLithiumSurcharges;
    const updated = current.includes(chargeType)
      ? current.filter(t => t !== chargeType)
      : [...current, chargeType];
    dispatch(bookingActions.updateField({ field: 'selectedLithiumSurcharges', value: updated }));
  };

  return (
    <div className="batteries-card horizontal-card">
      <p className="horizontal-card__title">Batteries</p>
      <table className="batteries-card__table">
        <tbody>
          {lithiumCharges.map(charge => (
            <tr
              key={charge.type}
              className={booking.selectedLithiumSurcharges.includes(charge.type) ? 'batteries-card__row--selected' : ''}
              onClick={() => handleToggle(charge.type)}
            >
              <td><div>{charge.type}{currencySymbol}</div><div>{charge.value.toFixed(2)}</div></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default BatteriesCard;
